import React from 'react';
import './index.less';

const Footer: React.FC = () => {
  // 动态加载图片
  const getImagePath = (imageName: string) => {
    try {
      // eslint-disable-next-line import/no-dynamic-require
      return require(`../../assets/icons/${imageName}.png`);
    } catch (e) {
      console.error('Image loading failed:', e);
      return ''; // 返回一个默认图片路径
    }
  };

  const imageUrl =
    'https://s3plus.meituan.net/v1/mss_e2821d7f0cfe4ac1bf9202ecf9590e67/cdn-prod/file:86dee248/%E7%BE%8E%E5%9B%A2%E5%9F%B9%E8%AE%ADlogo.png';

  return (
    <div className="footer-container">
      <div className="footer">
        <div className="top">
          <div className="left">
            <div className="logo">
              <img src={imageUrl} alt="" />
              <span className="_gy_number">生活服务业人才数字化发展的平台</span>
            </div>

            <div className="text">
              <span>
                长期致力于“提升职业技能、助力行业发展、促进产教融合、扩大社会就业”
                四方面的价值创造，让每一位生活服务业从业者与数字时代同行。
              </span>
            </div>
          </div>
          <div className="right">
            <div>
              <img src={getImagePath('qcCode')} alt="" />
              <span>扫码关注美团培训公众号</span>
            </div>
          </div>
        </div>
        <div className="website-information">
          <div>
            <span className="mr25">北京三快科技有限公司©meituan.com</span>
            <span className="mr25">京ICP证070791号 京ICP备10211739号-1</span>
            <span>京公网安备 11000002002052号</span>
          </div>

          <div>
            {/* <div className="mr34 icon">
              <img className="w12" src={getImagePath('iphone')} alt="" />
              <span>在线客服</span>
            </div> */}

            <div className="icon">
              <img className="w16" src={getImagePath('message')} alt="" />
              <span>1010-7888（工作时间：9:30-18:30）</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
